import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';

Chart.register(
  ArcElement,
  LinearScale,
  PointElement,
  CategoryScale,
  BarElement,
  LineElement,
  Legend,
  Title,
  Tooltip,
  annotationPlugin,
);
